import { SHOW_ERROR, HIDE_MESSAGE } from '../actions/actionTypes';

const initialState = {
    error: false,
    code: 0,
    message: "",
    title: "",
    other: ""
}
function ErrorReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_ERROR:
            return {
                ...state,
                error: true,
                code: action.payload.code,
                message: action.payload.message,
                title: action.payload.title,
                other: action.payload
            }
        case HIDE_MESSAGE:
            return initialState;
        default: return state;
    }
}
export default ErrorReducer;